import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { EventsService } from 'src/app/services/events.service';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { NgxAlertsService } from '@ngx-plus/ngx-alerts';
import { Base64ToFileProvider } from 'src/app/providers/file/base64-to-file';

@Component({
  selector: 'app-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.scss']
})
export class UploadImageComponent implements OnInit, OnChanges {

  @Input() removeOldImage: any;
  @Input() imageUpdate: any;
  @Input() isConfirm = false;
  @Output() confirmCropped: EventEmitter<any> = new EventEmitter<any>();

  imageChangedEvent: any = '';
  croppedImage: any = '';
  img: any;

  constructor(
    private eventsService: EventsService,
    private alert: NgxAlertsService,
    private toFile: Base64ToFileProvider
  ) {
  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.img = null;
    this.imageChangedEvent = null;
    if(this.imageUpdate) {
      this.imageChangedEvent = this.toFile.dataURLtoFile(this.imageUpdate, 'edit.png') ;
    }
  }

  fileChangeEvent(event: any): void {
    const size = (event.srcElement.files[0].size / 1000) / 1000;
    // console.log(size);
    if (size >= 19.07) {
      this.img = null;
      this.alert.alertError({ title: 'You can only select image up to 19.07 MB in size' });
      return;
    } else {
      this.imageChangedEvent = event;
    }
  }

  imageCropped(event: ImageCroppedEvent) {
      this.croppedImage = event.base64;
      this.eventsService.selectedImageSuccess.emit(this.croppedImage);
      if(!this.isConfirm) {
        this.confirmCropped.emit(this.croppedImage);
      }
  }

  confirm() {
    this.confirmCropped.emit(this.croppedImage);
  }

  imageLoaded() {
    // show cropper
  }

  cropperReady() {
    // cropper ready
  }

  loadImageFailed() {
    // show message
  }

}
